module.exports = __webpack_public_path__ + "static/img/exercise-1.751c2aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/exercise-1.png
// module id = cuFf
// module chunks = 1